module.exports = __webpack_public_path__ + "static/img/step_1.bf209f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/step_1.png
// module id = RM//
// module chunks = 1